import React, { useState } from 'react';

import { ChevronUpIcon } from 'lucide-react';

import { cn } from '../../utils/cn.js';

import { Badge } from './badge.jsx';

export default function BadgeList({
  items = [],
  maxlength = 20,
  status = { key: '', colors: {} },
}) {
  const [open, setOpen] = useState(false);
  const displayedItems = open ? items : items.slice(0, maxlength);

  return (
    <div
      className={cn(
        'flex h-auto min-h-10 w-full flex-1 flex-wrap items-center gap-1.5 overflow-x-hidden rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        !items.length && 'bg-zinc-300 dark:bg-zinc-800',
      )}
    >
      {!items.length
        ? null
        : displayedItems.map((item, i) => (
            <Badge variant="outline" key={i} className="rounded-full pr-1.5">
              {status.key && (
                <div
                  className={`mr-2 size-1 rounded-full ${status.colors[String(item[status.key])]}`}
                ></div>
              )}
              <span>{item.label}</span>
            </Badge>
          ))}

      {items.length > maxlength && (
        <div
          onClick={() => setOpen(!open)}
          className="py-.5 cursor-pointer text-xs leading-4 text-muted-foreground hover:underline"
        >
          {open ? (
            <ChevronUpIcon className="size-4" />
          ) : (
            <span>+{items.length - maxlength}</span>
          )}
        </div>
      )}
    </div>
  );
}
